import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=ddd125dc&scoped=true&"
import script from "./Presence.vue?vue&type=script&lang=js&"
export * from "./Presence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd125dc",
  null
  
)

export default component.exports